<template lang="pug">
v-form#defaultForm(ref="defaultForm", @submit.prevent="doSave", lazy-validation)
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="Tujuan Transaksi",
          required,
          :rules="[(v) => !!v || 'Input tujuan transaksi']"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Keterangan",
          required,
          :rules="[(v) => !!v || 'Input Keterangan']"
        )
    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="defaultForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FDefaultListForm",
  props: ["productId", "productGroup"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
      },
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset() {
      if (this.$refs.defaultForm) {
        this.$refs.defaultForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
      };
    },
    doSave() {
      if (this.$refs.defaultForm.validate()) {
        this.$emit("list", this.list);
        this.doReset();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
  },
};
</script>